function cov_1or0dr4fnf() {
  var path = "/app/src/components/long-term-content/components/limited-time-offer-badge/index.ts";
  var hash = "42b3dcf7144bbecb164ef181d1514f7febee9691";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/long-term-content/components/limited-time-offer-badge/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "42b3dcf7144bbecb164ef181d1514f7febee9691"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1or0dr4fnf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1or0dr4fnf();
export { LimitedTimeOfferBadge } from './limited-time-offer-badge';